var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass:
        "absolute top-1 right-4 lg:right-6 text-zinc-600 transition-opacity hover:opacity-50 focus:opacity-50",
      attrs: { type: "button", title: "Clear" },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("svg", { attrs: { width: "16", height: "16" } }, [
        _c("path", {
          attrs: { d: "M3,3 L13,13 M3,13 L13,3", stroke: "currentcolor" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }